export default "__VITE_ASSET__D2RJRV5A__"